<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="日期：">
            <el-date-picker :picker-options="pickerOptions" v-model="searchForm.SEND_DAY" type="date" placeholder="选择日期"
              :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="searchForm.value" placeholder="请选择">
              <el-option v-for="item in PRODUCT_TYPE_LIST" :key="item.typeId" :label="item.name" :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="一级大类：">
            <el-select v-model="searchForm.FL_CODE" placeholder="请选择" clearable>
              <el-option v-for="item in FIEST_CODE" :key="item.PRODUCT_CODE" :label="item.NAME"
                :value="item.PRODUCT_CODE">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="配送类型：">
            <el-select multiple filterable v-model="searchForm.DETAIL_TYPE" placeholder="请选择配送类型" clearable
              @change="serch">
              <el-option v-for="item in 团餐客户配送类型列表" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.PRODUCT_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="serch()" :loading="loadSearch">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="exportData()">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="BRAND" label="品牌"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="SPECIFICATION" label="规格"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="FL_NAME" label="所属大类"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="dataY(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-col>
    </el-row>
    <el-row style="margin-top:15px">
      <el-button size="medium" @click="exportEnterOrder()" :loading="loadSearch">资质更新</el-button>
      <el-button size="medium" @click="每日资质一键同步()" v-show="fun_dic[123020101]" :loading="loadSearch">
        每日资质一键同步
      </el-button>
    </el-row>
    <!-- 上传 -->
    <el-dialog :visible.sync="exportOrderDialog" title="资质上传" width="450px" center>
      <el-form ref="orderForm" :model="orderForm">
        <el-form-item v-for="(domain, index) in orderForm.domains" :label="'资质名称' + (index + 1) + ':'" :key="domain.key"
          :prop="'domains.' + index + '.value'">
          <div>
            <el-input v-model="domain.value" style="width:200px"></el-input>
            <el-button @click.prevent="removeDomain(domain)" style="margin-left:5px">删除</el-button>
          </div>
          <div class="upload">
            <el-upload class="upload-demo" action="/uploadFile" ref="upload"
              :before-remove="(file, fileList) => { return beforeRemove(file, fileList, index) }"
              :on-success="handleSuccess" :name="orderForm.orderName" multiple :file-list="domain.fileList">
              <el-button size="small" type="primary" @click="getNum(index)">点击上传</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button @click="addDomain">新增资质</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportOrderDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleExportOrder">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data () {
    return {
      PAGE_ID: 1230201,
      fun_dic: {
        123020101: 0,
      },
      loadSearch: false,
      tableData: [
      ],
      formLableWidth: '120px',
      PRODUCT_TYPE_LIST: [{ typeId: 0, name: '未上传' }, { typeId: 1, name: '已上传' }],
      FIEST_CODE: [],
      团餐客户配送类型列表: this.$util.团餐客户配送类型列表,
      searchForm: {
        SEND_DAY: new Date().getTime() + 3600 * 1000 * 24,
        value: 0,
      },
      val: [],
      PRODUCT_CODE: [],
      fileList: [],
      file_name: '',
      exportOrderDialog: false,
      orderForm: {
        orderName: 'qualification',
        domains: [{
          fileList: [],
          value: '',
          orderName: 'qualification',
        }],
      },
      X: 1,
      upNum: 0,
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
      pickerOptions: {
        disabledDate (time) {
          // const nowD = new Date()
          // return time.getTime() < nowD.getTime()
          // - 3600 * 1000 * 24;
        },
      },
    };
  },
  created () {
    if (this.SAVE_QUALIFIC_LIST) {
      this.searchForm = this.SAVE_QUALIFIC_LIST.CONDITION;
      this.currentPage = this.SAVE_QUALIFIC_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryProduct();
    this.queryData();
    this.queryBeforeFun();
  },
  computed: {
    // 上一次的搜索结果和条件
    SAVE_QUALIFIC_LIST () {
      return this.$store.state.SAVE_QUALIFIC_LIST;
    },
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    exportData () {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 43,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: date(this.searchForm.SEND_DAY, '%F'),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        UPLOADED: this.searchForm.value,
      };
      if (this.searchForm.FL_CODE) {
        params.FL_CODE = this.searchForm.FL_CODE;
      }
      if (this.searchForm.DETAIL_TYPE && this.searchForm.DETAIL_TYPE.length) {
        params.DETAIL_TYPE = this.searchForm.DETAIL_TYPE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((result) => {
        if (result.length && result[0] && result[0].FILE_PATH) {
          window.open(this.$util.getURLLocalHost(result[0].FILE_PATH));
        } else this.$message.show({ text: '暂无数据', type: 'warning' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    每日资质一键同步 () {
      const params = {
        SERVICE_ID: '100271',
        OTYPE: 8,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '同步成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 上传
    exportEnterOrder () {
      this.val.map((item) => {
        this.PRODUCT_CODE.push(item.PRODUCT_CODE);
      });
      if (this.val.length == 0) {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      } else {
        this.exportOrderDialog = true;
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
        } else {
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain (item) {
      const index = this.orderForm.domains.indexOf(item);
      if (index !== -1) {
        this.orderForm.domains.splice(index, 1);
      }
    },
    addDomain () {
      this.orderForm.domains.push({
        value: '',
        fileList: [],
        key: Date.now(),
      });
    },
    getNum (item) {
      this.upNum = item;
    },
    handleSuccess (response, file, fileList) {
      this.fileList = fileList;
      this.file_name = response.file_name;
      this.orderForm.domains[this.upNum].fileList = fileList;
    },
    beforeRemove (file, fileList, data) {
      this.orderForm.domains[data].fileList = fileList;
    },
    handleExportOrder () {
      const FILE_NAME = [];
      this.orderForm.domains.map((item) => {
        item.fileList.map((itemt) => {
          FILE_NAME.push({ NAME: item.value, URL: `${this.orderForm.orderName}/${itemt.response.file_name}` });
        });
      });
      const flag = this.orderForm.domains.find((item) => {
        if (item.fileList.length == 0) {
          return true;
        }
      });
      if (flag) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 5,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: date(this.searchForm.SEND_DAY, '%F'),
        FILE_NAME,
        PRODUCT_CODE: this.PRODUCT_CODE,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '上传成功', type: 'success' });
        this.queryData();
        this.orderForm.domains = [];
        this.exportOrderDialog = false;
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    serch () {
      this.currentPage = 1;
      this.queryData();
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryData();
    },
    queryData () {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 6,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: date(this.searchForm.SEND_DAY, '%F'),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        UPLOADED: this.searchForm.value,
      };
      if (this.searchForm.FL_CODE) {
        params.FL_CODE = this.searchForm.FL_CODE;
      }
      if (this.searchForm.DETAIL_TYPE && this.searchForm.DETAIL_TYPE.length) {
        params.DETAIL_TYPE = this.searchForm.DETAIL_TYPE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_SAVE_QUALIFIC_LIST', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.totalCount = 0;
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    queryProduct () {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 14,
      };
      http.post(params).then((result) => {
        this.FIEST_CODE = result;
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    handleSelectionChange (val) {
      this.PRODUCT_CODE = [];
      this.val = val;
    },
    dataY (row) {
      this.$router.push({ name: 'qualificatDetail' });
      sessionStorage.setItem('QUALIFICATION_SEND', date(this.searchForm.SEND_DAY, '%F'));
      sessionStorage.setItem('QUALIFICATION_CODE', row.PRODUCT_CODE);
      sessionStorage.setItem('QUALIFICATION_NAME', row.PRODUCT_NAME);
      sessionStorage.setItem('QUALIFICATION', JSON.stringify(row.QUALIFICATION));
      sessionStorage.setItem('QUALIFICATION_SPQ', JSON.stringify(row.SPQ_ID));
    },
  },
};
</script>
<style scoped>
/* .qualtion{
 position: relative;
}
.upload{
position: absolute;
top:0px;
right: 50px;
} */
</style>



// WEBPACK FOOTER //
// src/components/foodSecurity/qualificatManage.vue